module.exports = __webpack_public_path__ + "static/media/pefin-financial-plan-01.9d00d05e.png";